// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../interfaces/ipage";
import TabController from "./../factories/tab-controller";
import "./../bindings/bao-tabs";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import BaoDialog from "./../factories/bao-dialog";
import Bao from "./../services/bao-service";
import * as ko from "knockout";
class BillingGeneration {
    Name: KnockoutObservable<string> = ko.observable("");
    BillingGenerationSelectionTab: TabPage;
    BillingGenerationSettingsTab: TabPage;
    BillingGenerationStartTab: TabPage;
    TabPage: TabPage;
    TabController: TabController;
    //------------------------------------------------------- Selection-Tab
    ModelsCustomers = ko.observableArray([]);
    SelectionCustomers = ko.observableArray([]);
    PageSizeCustomers = ko.observable(20);
    PageIndexCustomers = ko.observable(0);
    SortingCustomers = ko.observable();
    TotalRowsCustomers = ko.observable();
    ModelsServiceProviders = ko.observableArray([]);
    SelectionServiceProviders = ko.observableArray([]);
    PageSizeServiceProviders = ko.observable(2000);
    PageIndexServiceProviders = ko.observable(0);
    SortingServiceProviders = ko.observable();
    TotalRowsServiceProviders = ko.observable();
    ModelsBillingType = ko.observableArray([]);
    SelectionBillingType = ko.observableArray([]);
    PageSizeBillingType = ko.observable(2000);
    PageIndexBillingType = ko.observable(0);
    SortingBillingType = ko.observable();
    TotalRowsBillingType = ko.observable();
    ModelsCIType = ko.observableArray([]);
    SelectionCIType = ko.observableArray([]);
    PageSizeCIType = ko.observable(2000);
    PageIndexCIType = ko.observable(0);
    SortingCIType = ko.observable();
    TotalRowsCIType = ko.observable();
    ModelsCIStatus = ko.observableArray([]);
    SelectionCIStatus = ko.observableArray([]);
    PageSizeCIStatus = ko.observable(2000);
    PageIndexCIStatus = ko.observable(0);
    SortingCIStatus = ko.observable();
    TotalRowsCIStatus = ko.observable();
    SourceIdents = ko.observableArray([]);
    SelectedSourceIdent = ko.observable("");
    OnlySourceIdent = ko.observable(false);
    OnlyCreditNote = ko.observable(false);
    AllCustomersSelected = ko.observable(false);
    AllServiceProvidersSelected = ko.observable(false);
    AllBillingTypesSelected = ko.observable(false);
    AllCITypesSelected = ko.observable(false);
    AllCIStatusSelected = ko.observable(false);
    OnlyApprovedSupport = ko.observable(false);
    ExcludeNullValues = ko.observable(false);
    LoadedCustomers = false;
    LoadedServiceProviders = false;
    LoadedBillingTypes = false;
    LoadedCITypes = false;
    LoadedCIStatus = false;
    LoadedSourceIdents = false;
    //------------------------------------------------------------------ Settings-Tab
    BillingFolderId = ko.observable("");
    BillingFolders = ko.observableArray([]);
    BillingFolderName = ko.observable("");
    BillingFolderItem = ko.observable();
    BillingFolderSearcherBinding = {
        ObjectId: this.BillingFolderId,
        ObjectValue: 'Name',
        SearchType: 'BillingFolder',
        AutoComplete: false,
        AutoSearch: true,
        SelectedItem: this.BillingFolderItem
    };
    ZeroValues = ko.observable(false);
    BillingName = ko.observable("");
    BillingPeriod = ko.observable();
    SelectedYear: KnockoutObservable<number> = ko.observable(new Date().getFullYear());
    SelectedMonth: KnockoutObservable<any> = ko.observable(1);
    Years: number[] = [];
    Months: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    //------------------------------------------------------------------ Start-Tab
    StartDate = ko.observable("");
    UserEmailAdress = ko.observable("");
    BindingDateTimeBox: Bindings.baoDateTimeBox = {
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol,
        value: this.StartDate
    };
    BindingDateTimePicker: Bindings.baoDateTimePicker = {
        mode: 'datetime'
    };
    constructor(tabPage: TabPage) {
        this.TabPage = tabPage;
        // --------------------------------------------------------------------------- Selection-Tab-Constructor
        this.GetCustomers();
        this.GetServiceProviders();
        this.GetBillingType();
        this.GetCIType();
        this.GetCIStatus();
        this.GetSourceIdent();
        this.PageIndexCustomers.subscribe(() => {
            this.GetCustomers();
        });
        this.SortingCustomers.subscribe(() => {
            this.GetCustomers();
        });
        this.PageIndexServiceProviders.subscribe(() => {
            this.GetServiceProviders();
        });
        this.SortingServiceProviders.subscribe(() => {
            this.GetServiceProviders();
        });
        this.PageIndexBillingType.subscribe(() => {
            this.GetBillingType();
        });
        this.SortingBillingType.subscribe(() => {
            this.GetBillingType();
        });
        this.PageIndexCIType.subscribe(() => {
            this.GetCIType();
        });
        this.SortingCIType.subscribe(() => {
            this.GetCIType();
        });
        this.PageIndexCIStatus.subscribe(() => {
            this.GetCIStatus();
        });
        this.SortingCIStatus.subscribe(() => {
            this.GetCIStatus();
        });
        //--------------------------------------------------------------------------------Settings-Tab-Constructor
        this.BillingFolderItem.subscribe((newValue) => {
            this.BillingFolderId(newValue["BillingFolderId"]);
        });
        this.BillingFolderId.subscribe((newValue) => {
        });
    }
    // ------------------------ CONSTRUCTOR END ---------------------------------------------------------------- Generate Billing (main tab)
    loaded() {
        Bao.Session.GetCaptions("BillingGeneration", Bao.Session.Language.Symbol).then((captions) => {
            this.TabPage.Title(captions.TabTitle);
        });
    }
    init() {
        return $.when(this.GetYearNumbers(), this.GetCurrentUserMail(), this.GetStartDate());
    }
    InitUrl() {
        return "";
    }
    StartBilling() {
        this.TabPage.IsLoading(true);
        return Bao.post("BillingGeneration/StartBilling", JSON.stringify({
            billingFolder: this.BillingFolderName(),
            billingFolderId: this.BillingFolderId(),
            billingName: this.BillingName(),
            year: this.SelectedYear(),
            month: this.SelectedMonth(),
            email: this.UserEmailAdress(),
            onlySourceIdent: this.OnlySourceIdent(),
            sourceIdent: this.SelectedSourceIdent(),
            customers: this.GetCustomerNames(),
            serviceProviders: this.GetServiceProviderNames(),
            billingTypes: this.GetBillingTypeNames(),
            ciTypes: this.GetCITypeNames(),
            ciStatus: this.GetCIStatusNames(),
            startDate: this.StartDate(),
            onlyApprovedSupport: this.OnlyApprovedSupport(),
            excludeNullValues: this.ZeroValues(),
            onlyCredit: this.OnlyCreditNote()
        }), ((result) => {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, result.message, "info");
        })).then(() => {
            this.TabPage.IsLoading(false);
        });
    }
    GetCustomerNames(): string[] {
        let customerNames = [];
        this.ModelsCustomers().forEach((customer) => {
            if (customer.IsSelected()) {
                customerNames.push(customer.ConfigurationItemId());
            }
        });
        return customerNames;
    }
    GetServiceProviderNames(): string[] {
        let ServiceProviderNames = [];
        this.ModelsServiceProviders().forEach((serviceProvider) => {
            if (serviceProvider.IsSelected()) {
                ServiceProviderNames.push(serviceProvider.ServiceProviderId());
            }
        });
        return ServiceProviderNames;
    }
    GetBillingTypeNames(): string[] {
        let billingTypeNames = [];
        this.ModelsBillingType().forEach((billingType) => {
            if (billingType.IsSelected()) {
                billingTypeNames.push(billingType.BillingTypeId());
            }
        });
        return billingTypeNames;
    }
    GetCITypeNames(): string[] {
        let ciTypeNames = [];
        this.ModelsCIType().forEach((ciType) => {
            if (ciType.IsSelected()) {
                ciTypeNames.push(ciType.ConfigurationItemTypeId());
            }
        });
        return ciTypeNames;
    }
    GetCIStatusNames(): string[] {
        let ciStatusNames = [];
        this.ModelsCIStatus().forEach((ciStatus) => {
            if (ciStatus.IsSelected()) {
                ciStatusNames.push(ciStatus.ConfigurationItemStatusId());
            }
        });
        return ciStatusNames;
    }
    // -------------------------------------------------------------------------------------------------------------- Selection-Tab 
    GetCustomers(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("BillingGeneration/GetCustomers", JSON.stringify({
            sorting: this.SortingCustomers(),
            pageIndex: this.PageIndexCustomers(),
            pageSize: this.PageSizeCustomers()
        }), (result: any) => {
            //result.ModelsCustomers[0]["IsSelected"](true);
            //this.ModelsCustomers(result.ModelsCustomers);
            ko.map.fromJS(result.ModelsCustomers, this.ModelsCustomers);
            this.TotalRowsCustomers(result.TotalRows);
        }).always(() => {
            this.LoadedCustomers = true;
            this.CheckLoadingGif();
            def.resolve();
        });
        return def.promise();
    }
    GetServiceProviders(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("BillingGeneration/GetServiceProviders", JSON.stringify({
            sorting: this.SortingServiceProviders(),
            pageIndex: this.PageIndexServiceProviders(),
            pageSize: this.PageSizeServiceProviders()
        }), (result: any) => {
            //this.ModelsServiceProviders(result.ModelsServiceProviders);
            ko.map.fromJS(result.ModelsServiceProviders, this.ModelsServiceProviders);
            this.TotalRowsServiceProviders(result.TotalRows);
        }).always(() => {
            this.LoadedServiceProviders = true;
            this.CheckLoadingGif();
            def.resolve();
        });
        return def.promise();
    }
    GetBillingType(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("BillingGeneration/GetBillingType", JSON.stringify({
            sorting: this.SortingBillingType(),
            pageIndex: this.PageIndexBillingType(),
            pageSize: this.PageSizeBillingType()
        }), (result: any) => {
            //this.ModelsBillingType(result.ModelsBillingType);
            ko.map.fromJS(result.ModelsBillingType, this.ModelsBillingType);
            this.TotalRowsBillingType(result.TotalRows);
        }).always(() => {
            this.LoadedBillingTypes = true;
            this.CheckLoadingGif();
            def.resolve();
        });
        return def.promise();
    }
    GetCIType(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("BillingGeneration/GetCIType", JSON.stringify({
            sorting: this.SortingCIType(),
            pageIndex: this.PageIndexCIType(),
            pageSize: this.PageSizeCIType()
        }), (result: any) => {
            //this.ModelsCIType(result.ModelsCIType);
            ko.map.fromJS(result.ModelsCIType, this.ModelsCIType);
            this.TotalRowsCIType(result.TotalRows);
        }).always(() => {
            this.LoadedCITypes = true;
            this.CheckLoadingGif();
            def.resolve();
        });
        return def.promise();
    }
    GetCIStatus(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("BillingGeneration/GetCIStatus", JSON.stringify({
            sorting: this.SortingCIStatus(),
            pageIndex: this.PageIndexCIStatus(),
            pageSize: this.PageSizeCIStatus()
        }), (result: any) => {
            //this.ModelsCIStatus(result.ModelsCIStatus);
            ko.map.fromJS(result.ModelsCIStatus, this.ModelsCIStatus);
            this.TotalRowsCIStatus(result.TotalRows);
        }).always(() => {
            this.LoadedCIStatus = true;
            this.CheckLoadingGif();
            def.resolve();
        });
        return def.promise();
    }
    GetSourceIdent(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post("BillingGeneration/GetSourceIdent", (result) => {
            ko.map.fromJS(result.SourceIdents, this.SourceIdents);
        }).always(() => {
            this.LoadedSourceIdents = true;
            this.CheckLoadingGif();
            def.resolve();
        });
        return def.promise();
    }
    SelectAllCustomers() {
        this.AllCustomersSelected(!this.AllCustomersSelected());
        this.ModelsCustomers().forEach((customer) => {
            customer["IsSelected"](this.AllCustomersSelected());
        });
    }
    SelectAllServiceProviders() {
        this.AllServiceProvidersSelected(!this.AllServiceProvidersSelected());
        this.ModelsServiceProviders().forEach((serviceProvider) => {
            serviceProvider["IsSelected"](this.AllServiceProvidersSelected());
        });
    }
    SelectAllBillingTypes() {
        this.AllBillingTypesSelected(!this.AllBillingTypesSelected());
        this.ModelsBillingType().forEach((billingType) => {
            billingType["IsSelected"](this.AllBillingTypesSelected());
        });
    }
    SelectAllCITypes() {
        this.AllCITypesSelected(!this.AllCITypesSelected());
        this.ModelsCIType().forEach((ciType) => {
            ciType["IsSelected"](this.AllCITypesSelected());
        });
    }
    SelectAllCIStatus() {
        this.AllCIStatusSelected(!this.AllCIStatusSelected());
        this.ModelsCIStatus().forEach((ciStatus) => {
            ciStatus["IsSelected"](this.AllCIStatusSelected());
        });
    }
    BindingForeachSelectionCustomers: Bindings.foreachSelection = {
        data: this.ModelsCustomers,
        mode: 'multi',
        pk: 'PrimaryKeyValue',
        selection: this.SelectionCustomers
    };
    BindingForeachSelectionServiceProviders: Bindings.foreachSelection = {
        data: this.ModelsServiceProviders,
        mode: 'multi',
        pk: 'PrimaryKeyValue',
        selection: this.SelectionServiceProviders
    };
    BindingForeachSelectionBillingType: Bindings.foreachSelection = {
        data: this.ModelsBillingType,
        mode: 'multi',
        pk: 'PrimaryKeyValue',
        selection: this.SelectionBillingType
    };
    BindingForeachSelectionCIType: Bindings.foreachSelection = {
        data: this.ModelsCIType,
        mode: 'multi',
        pk: 'PrimaryKeyValue',
        selection: this.SelectionCIType
    };
    BindingForeachSelectionCIStatus: Bindings.foreachSelection = {
        data: this.ModelsCIStatus,
        mode: 'multi',
        pk: 'PrimaryKeyValue',
        selection: this.SelectionCIStatus
    };
    SelectItem(item) {
        item["IsSelected"](!item["IsSelected"]());
    }
    CheckLoadingGif() {
        // to discard the loading gif only after all data is loaded.
        if (this.LoadedBillingTypes && this.LoadedCIStatus && this.LoadedCITypes && this.LoadedCustomers && this.LoadedServiceProviders && this.LoadedSourceIdents) {
            this.TabPage.IsLoading(false);
        }
    }
    // ------------------------------------------------------------------------------------------------------------------------------------------------- Settings-Tab
    //GetBillingFolders(): JQueryPromise<void> {
    //    var def = $.Deferred<void>();
    //    this.TabPage.IsLoading(true);
    //    Bao.post("BillingGeneration/GetBillingFolders", (result: any) => {
    //        this.BillingFolders(result.BillingFolders);
    //    }).always(() => {
    //        this.GotBillingFolders = true;
    //        this.CheckLoadingGif();
    //        def.resolve();
    //    });
    //    return def.promise();
    //}
    GetYearNumbers(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var currentYear = new Date().getFullYear();
            for (var r in result) {
                if (result[r] != null) {
                    this.Years.push(result[r].Key); //Liste mit jahreszahlen erstellen
                }
            }
            this.SelectedYear(currentYear);
        });
    }
    GetCurrentUserMail(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        return Bao.post("SynosetMasterData/GetCurrentUserMailAdress", JSON.stringify({}), (result) => {
            this.UserEmailAdress(result);
        });
    }
    GetStartDate(): JQueryPromise<void> {
        var def = $.Deferred<void>();
        return Bao.post("BillingGeneration/GetStartDate", JSON.stringify({}), (result) => {
            this.StartDate(result.startDate);
        });
    }
}
export default BillingGeneration;